import get from 'lodash/get';
import find from 'lodash/find';
import map from 'lodash/map';
import pick from 'lodash/pick';
import set from 'lodash/set';
import sortBy from 'lodash/sortBy';
import countries from './country.list.json';

export const getCountryFromCountryName = (name = '') => {
  const lowerCountryName = name.toLowerCase();

  let countryCode = '';
  let countryName = '';

  ({ code: countryCode, name: countryName } = pick(
    find(countries, country => get(country, 'name', '').toLowerCase() === lowerCountryName) || {
      code: '',
      name,
    },
    ['code', 'name']
  ));

  return {
    countryCode,
    countryName,
  };
};

export const getCountryCodeFromCountryName = (countryName = '') =>
  get(getCountryFromCountryName(countryName), 'countryCode', '');

export const getCountryList = () =>
  sortBy(
    map(countries, country => ({ countryName: country.name, countryCode: country.code })).filter(
      country => country.countryCode !== 'ZZ'
    ),
    country => country.countryName
  );

export const getL10nForCountryCode = (
  countryCode,
  l10nKeys = ['translations.zip', 'translations.state']
) =>
  l10nKeys.reduce((l10n, key) => {
    const country = countries[countryCode || get(window.merchantos, 'locale.country_code')];

    return set(l10n, key, get(country, `l10n.${key}`, get(countries.ZZ, `l10n.${key}`, '')));
  }, {});
